// extracted by mini-css-extract-plugin
export default {"formControl":"river-checkbox_formControl__b7ORV","checkBox":"river-checkbox_checkBox__pV5Aj","label":"river-checkbox_label__A-iP4","smallerIcon":"river-checkbox_smallerIcon__YnJkb"};